/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDarkMenuItemExpandableItemMenu } from "./d-theme-dark-menu-item-expandable-item-menu";

export class DThemeDarkMenuSidedItemExpandableItemMenu extends DThemeDarkMenuItemExpandableItemMenu {}
